export default __webpack_public_path__ + "static/media/mobile-touch.083d7575.svg";